import { BaseTheme, BaseColors } from "./themeRoot/config";

export const baseColorsByTheme = (baseTheme: BaseTheme = "orange"): BaseColors => {
	return {
		primary: baseTheme === "green" ? "#6C992E" : "#FF5F1F",
		darkPrimary: baseTheme === "green" ? "#537623" : "#FF5F1F",
		lightPrimary: baseTheme === "green" ? "#8DC63F" : "#FF5F1F",
		...baseColors,
	};
};

export const baseColors = {
	transparent: "rgba(0, 0, 0, 0)",
	secondary: "#CFC8C8",
	darkSecondary: "#CFC8C8",
	lightSecondary: "#CFC8C8",

	red: "#DD0707",
	lightRed: "#FF6161",
	whiteRed: "#ffd6d1",
	coolGrey: "#737373",

	orange: "#FF5F1F",
	darkOrange: "#BB3D00",
	lightOrange: "#FA6900",
	paleOrange: "#FFEBD6",

	limeGreen: "#27AA5E",
	paleLimeGreen: "#C7FFCC",

	success: "#27AA5E",
	successLight: "#B0F7CD",
	warning: "#EFA000",
	warningLight: "#FFEDBF",
	danger: "#DD0707",
	dangerLight: "#ffd6d1",
	advice: "#4B85F4",
	adviceLight: "#DDEFFF",

	veryDarkBlue: "#1E1F2E",
	veryDarkBlue2: "#131327",
	darkBlue: "#2C3464",
	darkBlue2: "#282D4D",
	moderateBlue: "#65689A",

	white: "#fff",

	grey50: "#F4F4F4",
	grey45: "#E6E6E6",
	grey40: "#D4D4D4",
	grey35: "#A7A7B0",
	grey30: "#959595",
	grey25: "#737373",
	grey20: "#383838",
	grey10: "#303030",
	grey05: "#1a1a1a",
	black: "#03031A",

	textPrimary: "#03031A",
	textSecondary: "#505061",
	textDisabled: "#B2A7A7",

	formLabel: "#4F4F54",
};
